<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container find_work">
        <div class="mb-3 alert alert-warning under-review" v-if="profile.status === 1">
          <i class="fa-solid fa-circle-exclamation"></i> Seu perfil está sendo analisado
          pela nossa equipe.
        </div>
        <div class="row">
          <div class="col-lg-8">
            <!-- <StartHere
              :telegram_id="this.profile.telegram_id"
              :completed_videos="this.completed_videos"
              :course_progress="this.course_progress"
            /> -->
            <div class="alert alert-info text-center mb-3 fw-bold" v-if="profile.plan === 'VirtapClub'">Você é membro do Virtap Club!</div>
            <MyCourses :courses="this.course_list" />
          </div>
          <div class="col-lg-4 col-sm-12">
            <NewestVideos :list="this.newest_videos" />
            <NewestProjects :list="this.newest_projects" :fullview="false" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isVisible">
    <!-- Botão retangular fixo -->
    <button
      v-if="showButton"
      @click="toggleBox"
      class="btn animate-bounce promo-banner"
      style="transform: translateX(-50%)"
    >
      🔔 Curso Gratuito Disponível!
    </button>

    <!-- Caixa de anúncio -->
    <transition name="fade-slide">
      <div
        v-if="showBox"
        class="card  banner-card-container"
      >
        <div class="card-header d-flex justify-content-between align-items-center">
          <strong>Curso gratuito com certificado!</strong>
          <button
            type="button"
            class="btn-close btn-small"
            @click="closeBox"
            aria-label="Fechar card"
          >
            x
          </button>
        </div>
        <div class="card-body">
          <p>
            🎓 Comece agora sua jornada como Assistente Virtual com o nosso curso gratuito de
            Introdução à Assistência Virtual da Virtap!
          </p>
          <a href="/curso/intro-av" class="btn w-100 mb-2 btn-small mt-2"
            >👉 Acesse agora!</a
          >
          <button class="btn bg-secondary w-100 btn-small" @click="closeBox">
            Fechar
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import StartHere from "../dashboard/StartHere.vue";
import MyCourses from "../dashboard/MyCourses.vue";
import NewestProjects from "../dashboard/NewestProjects.vue";
import NewestProposals from "../dashboard/NewestProposals.vue";
import NewestVideos from "../dashboard/NewestVideos.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: {
    SideBar,
    TopBar,
    MyCourses,
    StartHere,
    NewestProjects,
    NewestProposals,
    NewestVideos,
  },

  created() {
    this.$store.commit("setActiveSection", "DashboardPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadAssistantData();
  },

  data() {
    return {
      authUser: null,
      profile: null,
      removePicture: false,
      name: null,
      picture: null,
      email: null,
      whatsapp: null,
      acceptTerms: false,
      receiveNews: false,
      newest_projects: [],
      newest_videos: [],
      completed_videos: [],
      course_progress: null,
      course_list: null,
      showBox: false,
      showButton: true,
      isVisible: false,
      played: false
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadAssistantData() {
      this.$store.commit("setLoading", true);

      try {
        let assistantData = await AssistantManager.getAssistantData();
        this.profile = assistantData.profile;
        this.newest_projects = assistantData.newest_projects;
        this.newest_videos = assistantData.newest_videos;
        this.completed_videos = assistantData.completed_videos;
        this.course_progress = assistantData.course_progress;
        this.course_list = Object.values(this.course_progress)
          .filter((f) => f.totalClasses > 0)
          .sort((a, b) => {
            return a.registration_timestamp - b.registration_timestamp;
          });

        this.$store.commit("setActiveUser", this.profile);
        this.$store.commit("setLoading", false);
        this.isVisible = (this.profile.plan !== 'VirtapClub');
        if (!this.profile.telegram_id && this.profile.status !== 1) {
          //$("#communityModal").modal("show");
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },
    toggleBox() {
      this.showBox = !this.showBox;
      if(!this.played) {
        this.played =true;
        new Audio('/assets/sounds/ding.mp3').play();
      }
    },
    closeBox() {
      this.showBox = false;
      this.showButton = false;

      setTimeout(() => {
        this.isVisible = false;
      }, 300); // igual ao tempo da transição
    },
  },
};
</script>
